import { memo } from "react";
import { FormattedMessage } from "react-intl";
import "./FullyCustomizableNote.scss";
import { ALERT_TYPE } from "app/constants";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import AlertMessage from "app/components/ui/AlertMessage/AlertMessage";

const FullyCustomizableNote = () => {
	return (
		<AlertMessage
			message={
				<Typography variant={TYPOGRAPHY_VARIANTS.SMALL}>
					<FormattedMessage id="product.page.negociated.note" />
				</Typography>
			}
			className="fully-customizable-note"
			alertType={ALERT_TYPE.NEUTRAL}
			withIcon
		/>
	);
};

export default memo(FullyCustomizableNote);
